import React from 'react';
import { Button } from '../ui/button';
import { MessageCircle, Phone, ArrowRight } from 'lucide-react';
import { company } from '../../mock';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n';

const CTA = ({ onBookCall }) => {
  const { t } = useI18n();
  return (
    <section className="relative py-20 lg:py-24 overflow-hidden bg-slate-950">
      <div className="absolute inset-0 -z-0 opacity-60" style={{ backgroundImage: 'radial-gradient(600px 300px at 20% 30%, rgba(249,115,22,0.25), transparent 60%), radial-gradient(700px 300px at 90% 70%, rgba(59,130,246,0.25), transparent 60%)' }} />
      <div className="relative max-w-6xl mx-auto px-5 lg:px-8 text-center text-white">
        <span className="text-xs font-semibold uppercase tracking-widest text-orange-300">{t('cta.kicker')}</span>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold">
          {t('cta.titleA')} <span className="text-orange-400">{t('cta.titleB')}</span> {t('cta.titleC')}
        </h2>
        <p className="mt-4 text-slate-300 max-w-2xl mx-auto">{t('cta.body')}</p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/book-meeting">
            <Button className="h-12 px-6 bg-orange-500 hover:bg-orange-600 text-white font-semibold">{t('common.scheduleCall')} <ArrowRight className="h-4 w-4 ml-2" /></Button>
          </Link>
          <a href={`https://wa.me/${company.phoneRaw.replace('+', '')}`} target="_blank" rel="noreferrer">
            <Button className="h-12 px-6 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold">
              <MessageCircle className="h-4 w-4 mr-2" /> {t('common.chatOnWhatsapp')}
            </Button>
          </a>
          <a href={`tel:${company.phoneRaw}`}>
            <Button variant="outline" className="h-12 px-6 bg-transparent border-white/20 text-white hover:bg-white/10">
              <Phone className="h-4 w-4 mr-2" /> {company.phone}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
